const IndividualResourcePrintControls = () => {
  return null
}

export default IndividualResourcePrintControls
